/**
 * Shim for the touch-to-click emulation in theme.js.
 *
 * theme.js registers a `touchend` listener on document (bubble phase) that
 * calls e.preventDefault() on EVERY tap that is not a native form control,
 * and only afterwards checks whether the target is interactive
 * (a, button, label, select, summary, [role="button"]). If it is not, it
 * returns without dispatching a synthetic click. Net effect: the browser's
 * native click is cancelled and nothing replaces it, so the tap does nothing.
 *
 * That is exactly what happens to app widgets rendered in a shadow DOM
 * (Shopify Inbox chat bubble, Loox, Moast, Shopify Forms): the tap is
 * retargeted to the host element (e.g. <inbox-online-store-chat>), which
 * is not in that selector list. Result: the chat bubble is visible but
 * dead on every touch device. ZYNT works because its theme.js is the
 * original without this emulation.
 *
 * This shim listens on window in the CAPTURE phase, so it runs before the
 * theme's handler, and for taps the theme would drop it turns the event's
 * preventDefault() into a no-op. The theme's own buttons keep the emulated
 * click (its hover-style fix still works); everything else gets the
 * browser's normal behaviour back.
 *
 * Proper fix, when someone edits theme.js: move `e.preventDefault()` below
 * the `if (!interactive) return;` line. Then this file can be deleted.
 */
(function () {
  var THEME_INTERACTIVE = 'a, button, label, select, summary, [role="button"]';

  window.addEventListener(
    'touchend',
    function (e) {
      var target = e.target;
      if (!target || typeof target.closest !== 'function') return;

      // Retargeted from a shadow tree (composedPath()[0] is the real element,
      // e.target is the host the theme will see).
      var path = e.composedPath ? e.composedPath() : [];
      var fromShadow = path.length > 0 && path[0] !== target;

      // Host element of an open shadow root, or a third-party custom element.
      var isShadowHost = !!target.shadowRoot;

      // Anything the theme would not dispatch a synthetic click for.
      var themeWouldDrop = !target.closest(THEME_INTERACTIVE);

      if (fromShadow || isShadowHost || themeWouldDrop) {
        // Let the browser fire its native click for this tap.
        e.preventDefault = function () {};
      }
    },
    true
  );
})();
